import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { IndexCard, KroneKladdeUge } from '@store/models';
import { UgerapportUge, TimetrackDescription, UgerepDone, Ugerapport, KroneKladde, KrKladde } from '@store/models';
import { LuxonUtils } from '@shared';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientCasesDetailsContainerComponent } from 'app/shared/client-cases-details/client-cases-details.container';
import { NavigationService } from '../../core/navigation.service';

@Component({
    selector: 'app-money-log-ui',
    templateUrl: './money-log.component.html',
    styleUrls: ['../timetrack.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MoneyLogComponent {
    @Input() user: IndexCard;
    @Input() year: number;
    @Input() week: number;
    @Input() today: number;
    @Input() weekTotals: number[];
    @Input() kronekladde: KroneKladde[];
    @Input() ugerepDoneWeek: boolean[];
    @Output() saveKr = new EventEmitter<Partial<KrKladde>>();
    @Output() saveBeskrivelse = new EventEmitter<TimetrackDescription>();
    @Output() doneDay = new EventEmitter<UgerepDone>();

    displayColumns = [
        'glkundenr', 'kunde', 'sag', 'krDag1', 'krDag2', 'krDag3', 'krDag4', 'krDag5', 'krDag6', 'krDag7', 'ialt', 'sagskort'
    ];

    get weekHeaders() {
        return LuxonUtils.datesInWeek(this.year, this.week);
    }

    get weekTotalsSum() {
        return this.weekTotals.reduce((acc, cur) => acc + cur, 0);
    }

    constructor(
        private router: Router,
        private activeModal: NgbActiveModal,
        private modal: NgbModal,
        private navigationService: NavigationService
    ) {}

    trackByPid(_: number, sag: UgerapportUge) {
        return sag.pid;
    }

    onSaveKr(updatedData: {kr: number, beskrivelse: string}, sag: KroneKladdeUge, dag: number) {
        const partialKr: Partial<KrKladde> = {
            medID: this.user.cardId,
            kontor: this.user.kontor,
            sagID: sag.pid,
            dato: LuxonUtils.dateInWeek(this.year, this.week, dag),
            beskrivelse: updatedData.beskrivelse,
            kr: updatedData.kr,
            registreret: new Date()
        };
        this.saveKr.emit(partialKr);
    }

    onSaveBeskrivelse(beskrivelse: string, sag: KroneKladdeUge, dag: number) {
        const timeTrackdescription: TimetrackDescription = {
            dato: LuxonUtils.dateInWeek(this.year, this.week, dag),
            beskrivelse,
            sagID: sag.pid,
            medId: sag.krKladde[0]?.medID,
            kontor: sag.krKladde[0]?.kontor
        };
        this.saveBeskrivelse.emit(timeTrackdescription);
    }

    onClient(kid: number) {
        this.router.navigate(['clients', kid.toString()]);
        this.activeModal.close();
    }


    async onCase(sag: Ugerapport) {
        this.activeModal.close();
        await this.navigationService.openCase(sag.kid?.toString(), sag.pid?.toString(), sag.v2RegnskabsaarKundeId, sag.yid);
    }

    onDoneDay(day: number) {
        const ugerepDone: UgerepDone = {
            id: 0,
            mid: this.user.cardId,
            dato: LuxonUtils.dateInWeek(this.year, this.week, day + 1),
            cd: new Date(),
            kontor: this.user.kontor
        };
        this.doneDay.emit(ugerepDone);
    }

    onCaseCard(kid: number) {
        const caseCard = this.modal.open(ClientCasesDetailsContainerComponent, { size: 'lg'});
        caseCard.componentInstance.kid = kid;
    }
}
